import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import layoutComponentsDictionary from "./layout/layoutComponentsDictionary";
import logger from "js-logger";
import React from "react";
export var ListComponent = function (_a) {
    var layoutType = _a.layoutType, meta = _a.meta;
    var componentIndex = 0;
    if (layoutType) {
        var componentName = layoutType || "";
        var layoutComponentSettings = layoutComponentsDictionary.getLayoutComponent("".concat(componentName, "-list"));
        if (layoutComponentSettings) {
            logger.debug("[LAYOUT LIST] - Utilisation du composant \"".concat(layoutComponentSettings.name, "\" pour afficher le list du type \"").concat(componentName, "\"."));
            return React.createElement(layoutComponentSettings, {
                key: "element_list_".concat(componentIndex++),
                meta: meta,
            });
        }
    }
    return _jsx(_Fragment, {});
};
